import { call, put } from "redux-saga/effects";
import { getSubFormModuleCreatedRecords, getSubFormModuleGraphicalStatus, createTableColumnSubFormModule, updateTableColumnSubFormModule, bulkUploadSubFormModule, removeSubFormModuleById, createSubFormModule, getSubFormModuleList, getSubFormModuleListById, updateSubFormModuleById, subFormModuleLog } from "../../../../Services/apiService";
import { getSubFormModuleCreatedRecordsSuccess, getSubFormModuleCreatedRecordsFailure, getSubFormModuleGraphicalStatusSuccess, getSubFormModuleGraphicalStatusFailure, createTableColumnSubFormModuleSuccess, createTableColumnSubFormModuleFailure, updateTableColumnSubFormModuleSuccess, updateTableColumnSubFormModuleFailure, bulkUploadSubFormByIdSuccess, bulkUploadSubFormByIdFailure, removeSubFormByIdSuccess, removeSubFormByIdFailure, updateSubFormByIdSuccess, updateSubFormByIdFailure, getSubFormListByIdSuccess, getSubFormListByIdFailure, getSubFormListSuccess, getSubFormListFailure, createSubFormSuccess, createSubFormFailure, subFormModuleLogSuccess, subFormModuleLogFailure } from "../../../Slices/subFormSlice";

export function* getSubFormModuleListHandler(actions) {
    try {
        let response = yield call(getSubFormModuleList, actions?.payload);
        yield put(getSubFormListSuccess(response?.data));
    } catch (err) {
        let errResponse = err?.response?.data?.message;
        yield put(getSubFormListFailure(errResponse))
    }
}

export function* getSubFormModuleListByIdHandler(actions) {
    try {
        let response = yield call(getSubFormModuleListById, actions?.payload);
        yield put(getSubFormListByIdSuccess(response?.data));
    } catch (err) {
        let errResponse = err?.response?.data?.message;
        yield put(getSubFormListByIdFailure(errResponse))
    }
}

export function* updateSubFormModuleByIdHandler(actions) {
    try {
        console.log(actions)
        let response = yield call(updateSubFormModuleById, actions?.payload);
        yield put(updateSubFormByIdSuccess(response?.data));
    } catch (err) {
        let errResponse = err?.response?.data?.message;
        yield put(updateSubFormByIdFailure(errResponse))
    }
}

export function* createSubFormModuleHandler(actions) {
    try {
        let response = yield call(createSubFormModule, actions?.payload);
        yield put(createSubFormSuccess(response?.data));
    } catch (err) {
        let errResponse = err?.response?.data?.message;
        yield put(createSubFormFailure(errResponse))
    }
}

export function* removeSubFormModuleHandler(actions) {
    try {
        let response = yield call(removeSubFormModuleById, actions?.payload);
        yield put(removeSubFormByIdSuccess(response?.data));
    } catch (err) {
        let errResponse = err?.response?.data?.message;
        yield put(removeSubFormByIdFailure(errResponse))
    }
}

export function* bulkUploadSubFormModuleHandler(actions) {
    try {
        let response = yield call(bulkUploadSubFormModule, actions?.payload);
        yield put(bulkUploadSubFormByIdSuccess(response?.data));
    } catch (err) {
        let errResponse = err?.response?.data?.message;
        yield put(bulkUploadSubFormByIdFailure(errResponse))
    }
}

export function* createTableColumnSubFormModuleHandler(actions) {
    try {
        let response = yield call(createTableColumnSubFormModule, actions?.payload);
        yield put(createTableColumnSubFormModuleSuccess(response?.data));
    } catch (err) {
        let errResponse = err?.response?.data?.message;
        yield put(createTableColumnSubFormModuleFailure(errResponse))
    }
}

export function* updateTableColumnSubFormModuleHandler(actions) {
    try {
        let response = yield call(updateTableColumnSubFormModule, actions?.payload);
        yield put(updateTableColumnSubFormModuleSuccess(response?.data));
    } catch (err) {
        let errResponse = err?.response?.data?.message;
        yield put(updateTableColumnSubFormModuleFailure(errResponse))
    }
}

export function* getSubFormModuleCreatedRecordsHandler(actions) {
    try {
        let response = yield call(getSubFormModuleCreatedRecords, actions?.payload);
        yield put(getSubFormModuleCreatedRecordsSuccess(response?.data));
    } catch (err) {
        let errResponse = err?.response?.data?.message;
        yield put(getSubFormModuleCreatedRecordsFailure(errResponse))
    }
}

export function* getSubFormModuleGraphicalStatusHandler(actions) {
    try {
        let response = yield call(getSubFormModuleGraphicalStatus, actions?.payload);
        yield put(getSubFormModuleGraphicalStatusSuccess(response?.data));
    } catch (err) {
        let errResponse = err?.response?.data?.message;
        yield put(getSubFormModuleGraphicalStatusFailure(errResponse))
    }
}

export function* subFormModuleLogHandler(actions) {
    try {
        let response = yield call(subFormModuleLog, actions?.payload);
        yield put(subFormModuleLogSuccess(response?.data));
    } catch (err) {
        let errResponse = err?.response?.data?.message;
        yield put(subFormModuleLogFailure(errResponse))
    }
}